import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgUmbrella = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M21.375 13.25C21.375 10.7636 20.3873 8.37903 18.6291 6.62087C16.871 4.86272 14.4864 3.875 12 3.875C9.5136 3.875 7.12903 4.86272 5.37087 6.62087C3.61272 8.37903 2.625 10.7636 2.625 13.25L3.30083 12.6867C3.70165 12.3527 4.16506 12.102 4.66395 11.9493C5.16283 11.7967 5.68716 11.745 6.20624 11.7975C6.72532 11.85 7.22873 12.0054 7.68697 12.2548C8.14522 12.5043 8.54911 12.8426 8.875 13.25C9.2852 12.8393 9.77233 12.5135 10.3085 12.2912C10.8448 12.0689 11.4195 11.9544 12 11.9544C12.5805 11.9544 13.1552 12.0689 13.6915 12.2912C14.2277 12.5135 14.7148 12.8393 15.125 13.25C15.4509 12.8426 15.8548 12.5043 16.313 12.2548C16.7713 12.0054 17.2747 11.85 17.7938 11.7975C18.3128 11.745 18.8372 11.7967 19.3361 11.9493C19.8349 12.102 20.2984 12.3527 20.6992 12.6867L21.375 13.25Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 11.9558V20.1225C12 20.454 11.8683 20.772 11.6339 21.0064C11.3995 21.2408 11.0815 21.3725 10.75 21.3725C10.4185 21.3725 10.1005 21.2408 9.86612 21.0064C9.6317 20.772 9.5 20.454 9.5 20.1225"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 3.875V2.625"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.9 15.8333C20.7521 15.6782 20.5743 15.5546 20.3773 15.4702C20.1802 15.3858 19.9681 15.3423 19.7538 15.3423C19.5394 15.3423 19.3273 15.3858 19.1302 15.4702C18.9332 15.5546 18.7554 15.6782 18.6075 15.8333L17.625 16.845L16.6425 15.8333C16.4946 15.6782 16.3168 15.5546 16.1198 15.4702C15.9227 15.3858 15.7106 15.3423 15.4963 15.3423C15.2819 15.3423 15.0698 15.3858 14.8727 15.4702C14.6757 15.5546 14.4979 15.6782 14.35 15.8333C14.0451 16.1527 13.875 16.5772 13.875 17.0187C13.875 17.4603 14.0451 17.8848 14.35 18.2042L17.2758 21.23C17.3209 21.2772 17.3751 21.3149 17.4351 21.3406C17.4951 21.3662 17.5597 21.3795 17.625 21.3795C17.6903 21.3795 17.7549 21.3662 17.8149 21.3406C17.8749 21.3149 17.9291 21.2772 17.9742 21.23L20.9 18.2C21.2037 17.8809 21.373 17.4572 21.373 17.0167C21.373 16.5761 21.2037 16.1525 20.9 15.8333Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgUmbrella.displayName = 'SvgUmbrella';
export default SvgUmbrella;
